export default "__VITE_ASSET__TilgRoCg__"